import styled from "styled-components";
import * as Variable from "../../CSSVariables";
import deleteIcon from "../../assets/images/icons/ic_delete.svg";
import deleteIconBlue from "../../assets/images/icons/ic_delete_blue.svg";
import editIcon from "../../assets/images/icons/ic_edit.svg";
import editIconBlue from "../../assets/images/icons/ic_edit_blue.svg";
import menuIcon from "../../assets/images/icons/ic_menu_dots_v.svg";
import closeIcon from "../../assets/images/icons/ic_close.svg";

export const AddressStyle = styled.div`
  position: relative;
  margin-bottom: 12px;
  input {
    opacity: 0;
    position: absolute;
    left: -9999px;
    + label {
      > div {
        position: relative;
        cursor: pointer;
        border: 1px solid ${Variable.silver};
        border-radius: 8px;
        padding: 12px 50px 12px 18px;
        transition: all 0.05s ease;

        @media only screen and (min-width: ${Variable.mobile}) {
          padding: 12px 110px 12px 18px;
        }

        &:hover {
          border: 1px solid ${Variable.congressBlue};
        }
        > p {
          margin: 4px 0;
        }
        .default-label {
          font-weight: ${Variable.medium};
        }
        .addressName {
          font-size: 1.8rem;
          font-weight: ${Variable.medium};
        }
      }
    }
    &:checked {
      + label {
        > div {
          border: 2px solid ${Variable.mineShaft};

          .default-label {
            display: block;
          }
        }
      }
    }
  }
  .mobile-action-toggle-checkbox {
    @media only screen and (min-width: ${Variable.desktop}) {
      display: none;
    }
    ~ .action-wrapper {
      display: none;
      right: 32px;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      transform: none;
      padding: 25px 20px 25px 0;
      background-color: #ffffffa6;
      text-align: right;

      @media only screen and (min-width: ${Variable.desktop}) {
        display: table;
        position: absolute;
        right: 0;
        left: unset;
        top: 50%;
        transform: translateY(-50%);
        padding: 0;
        background-color: transparent;
        text-align: right;
      }
    }
    ~ .mobile-action-toggle-btn {
      &::after {
        content: "";
        background-image: url(${menuIcon});
        background-repeat: no-repeat;
        background-size: contain;
        height: 18px;
        width: 18px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
        cursor: pointer;
      }
    }
    &:checked {
      ~ .mobile-action-toggle-btn {
        &::after {
          background-image: url(${closeIcon});
        }
      }
      ~ .action-wrapper {
        display: block;
        @media only screen and (min-width: ${Variable.desktop}) {
        }
      }
    }
  }
  .mobile-action-toggle-btn {
    color: transparent;
    font-size: 0;
    right: 16px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;

    @media only screen and (min-width: ${Variable.desktop}) {
      display: none;
    }

    img {
      height: 18px;
    }
  }
`;
export const AddressActionStyle = styled.div`
  display: inline-block;
  position: absolute;
  right: 0;
  top: 0;
  top: 50%;
  transform: translateY(-50%);

  .action {
    cursor: pointer;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    border: 0;
    background-color: transparent;
    width: 20px;
    height: 20px;
    margin-right: 30px;
    font-size: 0;
    color: transparent;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    display: inline-block;
    vertical-align: middle;

    @media only screen and (min-width: ${Variable.mobile}) {
      position: static;
      transform: none;
    }

    &.delete {
      background-image: url(${deleteIcon});
      right: 75px;
      // transition: all 0.1s;

      &:hover {
        background-image: url(${deleteIconBlue});
      }
    }
    &.edit {
      background-image: url(${editIcon});
      right: 25px;
      // transition: all 0.1s;

      &:hover {
        background-image: url(${editIconBlue});
      }
    }
  }
`;

export const EditToggle = styled.input`
  border: 1px solid red;

  ~ div.address-form {
    display: none;
  }
  ~ div.address-option {
  }
  &:checked {
    ~ div.address-option {
      display: none;
    }
    ~ div.address-form {
      display: block;
    }
  }
`;
